import React from 'react';
import PropTypes from 'prop-types';

import CustomTypes from '../../../types';

import { TitleStyled } from './Title.styled';
import '../../../core/stylesheet.css';

const Title = React.forwardRef(({
  as,
  children,
  content,
  modifiers,
  ...props
}, ref) => (
  <TitleStyled ref={ref} modifiers={modifiers} as={as} {...props}>
    {children || content}
  </TitleStyled>
));

Title.propTypes = {
  as: PropTypes.string,
  children: PropTypes.node,
  content: PropTypes.node,
  modifiers: CustomTypes.oneOrMore(['', 'small', 'medium', 'xLarge', 'micro', 'hero', 'primary', 'xSmall', 'light', 'inverted']),
};

Title.defaultProps = {
  as: '',
  children: null,
  content: '',
  modifiers: '',
};

export default Title;
